import $ from './lib/load_jquery';
import './lib/modernizr-3.8.0.min.js';
import 'jquery-ui/ui/version';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/position';
import 'jquery-ui/ui/keycode';
import 'jquery-ui/ui/unique-id';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-de';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/menu';
import 'slick-carousel';
import 'jquery.rateit/scripts/jquery.rateit';
import getSlug from 'speakingurl/lib/speakingurl';
//import './lib/plugins_orig';
// Plugins_orig Start
import './lib/native-console.js';
/*import './lib/outdatedBrowser.min.js';*/
import './lib/jquery.scrollTo.min.js';
import './lib/jquery.panzoom.min.js';
import './lib/swipebox.min.js';
import './lib/shariff.min.js';
import './lib/jquery.focuspoint';
//Plugins_orig Ende
import 'skeletabs/dist/skeletabs';
import 'lazysizes';
import Swiper from 'swiper';
import 'hammerjs/hammer';
import Cookies from 'js-cookie';
import 'parsleyjs';
import swal from 'sweetalert';
//import 'bootstrap';
import './pages/index.js';
import './pages/events.js';
import './pages/news.js';
import './pages/signpost.js';
import './pages/searchresult_list.js';


var isTouch = false,
    scrollTop;

$(document).ready(function() {
    //Outdated Browser
    // var v = outdatedBrowser({
    //     lowerThan: 'js:Promise',
    //     languagePath: $('#outdated').attr('data-lang') || ''
    // });

    /* Teaser */
    if ($('#teaserSection').length!=0) {
        var slickTeaserNode = $('#teaserSection #teaser'),
            vimeoPlayers = [],
            vimeoNodes = slickTeaserNode.find('.teaserVideoVimeo');

        /*initSlider*/
        slickTeaserNode.slick({
            speed: 800,
            infinite: true,
            nextArrow: '.slick-button-next',
            prevArrow: '.slick-button-prev',
            autoplay: true,
            autoplaySpeed: 6000,
            dots: true,
        });

        // Pause Slider
        $('.slick-button-pause').on('click', '.icon-pause', function() {
            slickTeaserNode.slick('slickPause');
            $(this).removeClass('icon-pause').addClass('icon-play');
        });

        // Play Slider
        $('.slick-button-pause').on('click', '.icon-play', function() {
            slickTeaserNode.slick('slickPlay');
            $(this).removeClass('icon-play').addClass('icon-pause');
        });


        /* resize video */
        vimeoNodes.each(function(index) {
            var videoNode = $(this).addClass('videoSizeJs'),
                videoContainerNode = videoNode.parent(),
                videoSlickTrack = videoNode.closest('.slick-slider'),
                videoRatio = videoNode.attr('height') / videoNode.attr('width');
            var videoResizeFn = function() {
                var videoContainerHeight = videoContainerNode.height(),
                    videoSlickTrackHeight = videoSlickTrack.height(),
                    videoContainerWidth = videoContainerNode.width(),
                    videoContainerRatio = videoContainerHeight / videoContainerWidth;

                if (videoRatio>videoContainerRatio) {
                    videoNode.css({
                        height : (videoContainerWidth * videoRatio) + 'px',
                        width : videoContainerWidth + 'px'
                    });
                } else {
                    videoNode.css({
                        height : videoContainerHeight + 'px',
                        width : (videoContainerHeight / videoRatio) + 'px'
                    });
                }
            };

            $(window).on('resize.video', function() {
                videoResizeFn();
            });

            videoResizeFn();

            if (klaro.getManager().getConsent("vimeo")) {

                /* init player */
                if (typeof Vimeo !== 'undefined') {
                    var player = new Vimeo.Player(this, {autopause: true});
                    player.on('ended', function(data) {
                        slickTeaserNode.slick('slickNext');
                        slickTeaserNode.slick('slickPlay');
                    });
                    vimeoPlayers.push(player);
                }

            }



            slickTeaserNode.on('beforeChange',function (event, slick, currentSlide, nextSlide) {
                var video = $(slick.$slides.get(nextSlide)).find('.teaserVideoVimeo'),
                    videoPlayerIndex = vimeoNodes.index(video);

                if (video.length!=0) {
                    if (videoPlayerIndex!==-1 && typeof vimeoPlayers[videoPlayerIndex]!=='undefined') {
                        videoResizeFn();
                    }
                }


            });
            slickTeaserNode.on('beforeChange',function (event, slick, currentSlide, nextSlide) {
                var video = $(slick.$slides.get(currentSlide)).find('.teaserVideoVimeo'),
                    videoPlayerIndex = vimeoNodes.index(video);

                if (video.length!=0) {
                    if (videoPlayerIndex!==-1 && typeof vimeoPlayers[videoPlayerIndex]!=='undefined') {
                        vimeoPlayers[videoPlayerIndex].pause();
                    }
                }


            });
            slickTeaserNode.on('afterChange',function (event, slick, currentSlide, nextSlide) {
                var video = $(slick.$slides.get(currentSlide)).find('.teaserVideoVimeo'),
                    videoPlayerIndex = vimeoNodes.index(video);

                if (video.length!=0) {
                    if (videoPlayerIndex!==-1 && typeof vimeoPlayers[videoPlayerIndex]!=='undefined') {
                        vimeoPlayers[videoPlayerIndex].play();
                        slickTeaserNode.slick('slickPause');
                    }
                }

            });
        });

    }

    /* mobile:  */
    $('#navMenuSwitch').on('change', function() {
        if ($(this).is(':checked')) {
            $('body').addClass('navMainOpen');
            $('#siteSearchSwitch, #languageSelectSwitch, #facebookSwitch, #instagramSwitch').prop('checked', false);
        } else {
            $('body').removeClass('navMainOpen');
        }
    });

    $('#siteSearchSwitch').on('change', function() {
        if ($(this).is(":checked")) {
            $('#srcBoxQ').get(0).focus();
            $('#languageSelectSwitch, #facebookSwitch, #instagramSwitch').prop('checked', false);
        }
    });

    $('.facebookbutton').on('click', function(event) {
        event.preventDefault();
        $('#facebookSwitch').prop('checked', true);
        $('#siteSearchSwitch, #languageSelectSwitch').prop('checked', false);
        $(document).mouseup(function(e)
        {
          var container = $("#facebooklinks");

          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0)
          {
            $('#facebookSwitch').prop('checked', false);
          }
        });
    });

    $('.instagrambutton').on('click', function(event) {
      event.preventDefault();
      $('#instagramSwitch').prop('checked', true);
      $('#siteSearchSwitch, #languageSelectSwitch').prop('checked', false);
      $(document).mouseup(function(e)
      {
        var container = $("#instagramlinks");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0)
        {
          $('#instagramSwitch').prop('checked', false);
        }
      });
    });

    $('#languageSelectSwitch').on('change', function() {
        if ($(this).is(":checked")) {
            $('#siteSearchSwitch, #facebookSwitch, #instagramSwitch').prop('checked', false);
        }
    });

    //Trigger Autocomplete / Suggest
    $('.siteSearchTrigger').on('click', function() {
       $('#siteSearchSwitch').prop('checked', true);
       $('#facebookSwitch').prop('checked', false);
       $('#instagramSwitch').prop('checked', false);
       $('#autocomplete-container').show();
        setTimeout(function(){
            $('#autocomplete-input').focus();
        }, 500); //Timeout for Safari
       $('.darken_content').css({
           'opacity' :'0.96',
           'z-index' : '10'
       });
    });

    $('.close-autocomplete').on('click', function() {
        $('#siteSearchSwitch').prop('checked', false);
        $('#autocomplete-container').hide();
        $('.darken_content').css({
            'opacity' :'0',
            'z-index' : '-1'
        });
    });

    $('.modalSwitch').each(function() {
        var node = $(this),
            checker = function() {
                if (node.is(':checked')) {
                    $('body').addClass('overlayOpen');
                } else {
                    $('body').removeClass('overlayOpen');
                }
            }
        node.on('change', function() {
            checker();
        });
        checker();
    });

    /* desktop: touch helper for mobile devices (e.g. tablets) for main navigation */
    $('#navMain li.lvl1 > .navBtnWrap a').on('touchstart click', function(event) {
        var li = $(this).closest('li');
        if (event.type=='touchstart') {
            isTouch = true;
        }

        if ($('#navMenuTrigger').is(':hidden') && event.type=='touchstart' && li.find('ul').length!=0 && !li.hasClass('hover')) {
            event.preventDefault();
            li.siblings().removeClass('hover');
            li.addClass('hover').trigger('mouseenter');
        }
    });

    /* cookie note */
    $('#cookieNote .closeNoteBtn').one('click', function(event) {
        event.preventDefault();
        Cookies.set('cookieNoteViewed', '1', { expires: 365 });
        $('#cookieNote').animate({opacity: 0, bottom: "-" + $('#cookieNote').outerHeight() + 'px'}, function() {
            $(this).remove();
        });
    });

    /* automatic resize fonts */
    var fsSizes = ['S', 'M', 'L', 'XL', 'XXL'],
        fs = 'M',
        fsBtn = $('#fontSizeSwitcher a'),
        fsSet = function(newIndex) {
            $('#wrapper').removeClass('fontSize' + fs);
            fsBtn.removeClass('disabled');

            if (newIndex==0) {
                fsBtn.filter('.decrease').addClass('disabled');
            } else if (newIndex==(fsSizes.length - 1)) {
                fsBtn.filter('.increase').addClass('disabled');
            }

            fs = fsSizes[newIndex];
            $('#wrapper').addClass('fontSize' + fs);
            Cookies.set('fontSize', fs);
        };

    if (Cookies.get('fontSize') && fsSizes.indexOf(Cookies.get('fontSize'))!==-1) {
        fs = Cookies.get('fontSize');
    }

    fsBtn.on('click', function(event) {
        event.preventDefault();
        var mode = $(this).hasClass('increase') ? 'up' : 'down',
            currentIndex = fsSizes.indexOf(fs);

        if (currentIndex!==-1) {
            if (currentIndex!=0 && mode=='down') {
                currentIndex--;
            } else if (currentIndex<(fsSizes.length - 1) && mode=='up') {
                currentIndex++;
            }

            fsSet(currentIndex);
        }
    });
    fsSet(fsSizes.indexOf(fs));

    /* Tiny Slider */
    if ( $( ".tiny-slider-gallery" ).length ) {
        var slider = tns({
            "container" : ".tiny-slider-container",
            "items"     : 1,
            "autoplay"  : false,
            "slideBy"   : 'page',
            "prevButton": '.tiny-button-prev',
            "nextButton": '.tiny-button-next',
            "navContainer": ".tiny-slider-gallery-thumbs",
        });
        var thumbsslider = tns({
            "container" : ".tiny-slider-gallery-thumbs",
            "items"     : 4,
            "slideBy"   : 1,
            "controls": false,
        });
    }

    /**
     * Name           : Slick-Slider
     * Beschreibung   : the last carousel you'll ever need
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, https://kenwheeler.github.io/slick/
     */
    /*
    if ( $('.slick-slider .header-slider').length ) {
        $('.slick-slider .header-slider').slick({
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            prevArrow: '.slick-button-prev',
            nextArrow: '.slick-button-next',
            fade: true,
        });
    }
    */


    if ( $('.slick-slider-gallery').length ) {
        $('.slick-slider-gallery').each(function(){
            $(this).find('.slick-slider-container').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                prevArrow: $(this).find('.slick-button-prev'),
                nextArrow: $(this).find('.slick-button-next'),
                fade: true,
                asNavFor: '.slider-nav'
            });
            $('.slider-nav').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: '.slider-for',
                dots: false,
                centerMode: true,
                centerPadding: '0px',
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                        }
                    }
                ]
            });
        });
    }

    /* Slick Slider Video*/
    if ( $('.main-slider').length ) {
        /*
        $('.slick-slider-video .slick-slider-container').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            prevArrow: '.slick-button-prev',
            nextArrow: '.slick-button-next',
            fade: true,
            asNavFor: '.slider-nav'
        });
        $('.slider-nav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: false,
            centerMode: true,
            centerPadding: '0px',
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });
*/
        /*Video in Slider*/
        var slideWrapper = $(".main-slider"),
            iframes = slideWrapper.find('.embed-player'),
            lazyImages = slideWrapper.find('.slide-image'),
            lazyCounter = 0;

// POST commands to YouTube or Vimeo API
        function postMessageToPlayer(player, command){
            if (player == null || command == null) return;
            player.contentWindow.postMessage(JSON.stringify(command), "*");
        }

// When the slide is changing
        function playPauseVideo(slick, control){
            var currentSlide, slideType, startTime, player, video;

            currentSlide = slick.find(".slick-current");
            slideType = currentSlide.find('.item').attr("class").split(" ")[1];
            player = currentSlide.find("iframe").get(0);
            startTime = currentSlide.data("video-start");

            if (slideType === "vimeo") {
                switch (control) {
                    case "play":
                        if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
                            currentSlide.addClass('started');
                            postMessageToPlayer(player, {
                                "method": "setCurrentTime",
                                "value" : startTime
                            });
                        }
                        postMessageToPlayer(player, {
                            "method": "play",
                            "value" : 1
                        });
                        break;
                    case "pause":
                        postMessageToPlayer(player, {
                            "method": "pause",
                            "value": 1
                        });
                        break;
                }
            } else if (slideType === "youtube") {
                switch (control) {
                    case "play":
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "mute"
                        });
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "playVideo"
                        });
                        break;
                    case "pause":
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "pauseVideo"
                        });
                        break;
                }
            } else if (slideType === "video") {
                video = currentSlide.children("video").get(0);
                if (video != null) {
                    if (control === "play"){
                        video.play();
                    } else {
                        video.pause();
                    }
                }
            }
        }

// Resize player
        function resizePlayer(iframes, ratio) {
            if (!iframes[0]) return;
            var win = $(".main-slider"),
                width = win.width(),
                playerWidth,
                height = win.height(),
                playerHeight,
                ratio = ratio || 16/9;

            iframes.each(function(){
                var current = $(this);
                if (width / ratio < height) {
                    playerWidth = Math.ceil(height * ratio);
                    current.width(playerWidth).height(height).css({
                        left: (width - playerWidth) / 2,
                        top: 0
                    });
                } else {
                    playerHeight = Math.ceil(width / ratio);
                    current.width(width).height(playerHeight).css({
                        left: 0,
                        top: (height - playerHeight) / 2
                    });
                }
            });
        }

// DOM Ready
        $(function() {
            // Initialize
            slideWrapper.on("init", function(slick){
                slick = $(slick.currentTarget);
                setTimeout(function(){
                    playPauseVideo(slick,"play");
                }, 1000);
                resizePlayer(iframes, 16/9);
            });
            slideWrapper.on("beforeChange", function(event, slick) {
                slick = $(slick.$slider);
                playPauseVideo(slick,"pause");
            });
            slideWrapper.on("afterChange", function(event, slick) {
                slick = $(slick.$slider);
                playPauseVideo(slick,"play");
            });
            slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
                lazyCounter++;
                if (lazyCounter === lazyImages.length){
                    lazyImages.addClass('show');
                    // slideWrapper.slick("slickPlay");
                }
            });

            //start the slider
            slideWrapper.slick({
                fade:true,
                autoplaySpeed:4000,
                lazyLoad:"progressive",
                speed:600,
                slidesToScroll: 1,
                arrows:true,
                prevArrow: '.slick-button-prev',
                nextArrow: '.slick-button-next',
                dots:true,
                cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
                asNavFor: '.slider-nav'
            });
            $('.slider-nav').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: '.slider-for',
                dots: false,
                centerMode: true,
                centerPadding: '0px',
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                        }
                    }
                ]
            });
        });

        /**
         * Name           : Resize event
         * Beschreibung   : -
         * Parameter      : -
         * Rückgabe       : -
         * Bibliothek     : -
         */
        $(window).on("resize.slickVideoPlayer", function(){
            resizePlayer(iframes, 16/9);
        });
    }

    /**
     * Name           : Autocomplete
     * Beschreibung   : Autocomplete/Autosuggest für Suche
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, jQueryUI
     */
    if ( $('#autocomplete-input').length ) {
        $(function () {
            //var md = 120035;
            var md = $('body').data('mandator-id'); //Auslesen der aktuellen Mandanten-id

            $("#autocomplete-input").autocomplete({
                appendTo: "#autocomplete-hits",
                autoFocus: true,
                minLength: 3,
                delay: 500,
                position: {my: "right top", at: "right top", of: "#autocomplete-container"},
                source: function (request, response) {
                    //$.getJSON(location.protocol+'//'+location.hostname + "/api/SuggestApi.php", {
                    //$.getJSON("/public/SuggestApi.php", {
                    $.getJSON("/api/SuggestApi.php", {
                        search: request.term,
                        mandator: md
                    }, function (data) {
                        // data is an array of objects and must be transformed for autocomplete to use
                        var array = data.error ? [] : $.map(data, function (m) {
                            return {
                                label: m.title,
                                id: m.id,
                                //url: "/sixcms/detail.php?id=" + m.id,
                                url: "/" + getSlug(m.title) + "." + m.id + ".htm",
                                //preview_url: "/public/preview.php",
                                preview_url: "/sixcms/detail.php?id=" + m.id + '&template=d_search_preview',
                                area: m.area
                            };
                        });
                        response(array);
                    });
                },
                focus: function (event, ui) {
                    event.preventDefault();
                    $("#autocomplete-details").load(ui.item.preview_url);
                    return false;
                },
                select: function (event, ui) {
                    if (ui.item) {
                        event.preventDefault();
                        //$("#autocomplete-input").val(ui.item.label);
                        $( "#autocomplete-details" ).load( ui.item.url );
                        location.href = ui.item.url;
                    }
                    return false;
                },
                open: function (event, ui) {
                    $("#autocomplete-container").show();
                    $("#autocomplete-hits").show();
                    $('.ui-autocomplete').append('<li class=\"pinned primary-bg\"><a class=\"trigger-submit\" href="' + $('.siteSearchTrigger').data('search-uri') + '?search=' + $("#autocomplete-input").val() + '"> Alle Suchergebnisse</a></li>'); //See all results
                    //$('.darken_content').css('z-index','9').css('opacity','0.8');
                },
                close: function (event, ui) {
                    setTimeout(
                        function()
                        {
                            $(".autocomplete-content").remove();
                        }, 200);
                },
                messages: {
                    noResults: '',
                    results: function () {
                    }
                }
            })
                .autocomplete("instance")._renderItem = function (ul, item) {
                return $("<li>")
                    .append("<a href=" + item.url + " class=\"ui-menu-item-wrapper\"><div class=\"autocomplete-link-wrapper\"><div class=\"area\">" + item.area + "</div><span>" + item.label + "<br></span></div></a>")
                    .appendTo(ul);
            };
        });
    }

    /**
     * Name           : Jquery Focuspoint
     * Beschreibung   : -
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, https://github.com/jonom/jquery-focuspoint
     */
    if ( $('.focuspoint').length ) {
        console.log("focuspoint-item detected");
        $('.focuspoint').focusPoint();
    }

    afterAjax();
});

function afterAjax() {

    /**
     * Name           : shariff
     * Beschreibung   : Shariff enables website users to share their favorite content without compromising their privacy
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : https://github.com/heiseonline/shariff
     */
    var buttonsContainer = $('#share .shariff');
    if (buttonsContainer.length!=0) {
        new Shariff(buttonsContainer);
    }

    /**
     * Name           : Gallery
     * Beschreibung   : -
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */
    $('.gallery').each(function() {
        var galleryNode = $(this).find('.gallery-top'),
            galleryThumbsNode = $(this).find('.gallery-thumbs'),
            galleryThumbs,
            gallery,
            galleryOpts = {
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'



                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }

        if (galleryNode.length!=0) {
            if (galleryThumbsNode.length!=0) {
                galleryThumbs = new Swiper(galleryThumbsNode[0], {
                    loop: true,
                    slidesPerView: 'auto',
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true
                });

                galleryOpts.thumbs = {
                    swiper: galleryThumbs
                };
            }

            gallery = new Swiper(galleryNode[0], galleryOpts);
        }
    });

    /**
     * Name           : Swipebox
     * Beschreibung   : A touchable jQuery lightbox
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, https://brutaldesign.github.io/swipebox/
     */
    $('.imgTrigger').swipebox({
        removeBarsOnMobile : false,
        hideBarsDelay : 0,
        vimeoColor : 'd1002b',
        autoplayVideos : true,
        beforeOpen : function () {
            scrollTop = $(window).scrollTop();
        },
        afterClose : function () {
            if (scrollTop) {
                setTimeout(function() {
                    window.scrollTo(0, scrollTop);
                }, 1);
            }
        }
    });


    /**
     * Name           : Formular - Handling (Select, Radio-Buttons
     * Beschreibung   : nur übernommen
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : -
     */
    $('.optsInline input:radio, .optsInline input:checkbox').off('click.checked change.checked').on('click.checked change.checked' , function() {
        $('input:radio[name="'+$(this).attr('name')+'"]').closest('.optsInline').removeClass('optsChecked');
        if ($(this).is(':checked')) {
            $(this).closest('.optsInline').addClass('optsChecked');
        } else {
            $(this).closest('.optsInline').removeClass('optsChecked');
        }
    }).filter(':checked').trigger('change.checked');

    $('.optsInline').on('click.checked', function(event) {
        if ($(this).is(event.target)) {
            $(this).find('input:radio, input:checkbox').trigger('click.checked');
        }
    });

    $('.form select:not(.select-morphed):not(.optsCounter)').each(function() {
        var sel = $(this).addClass('select-morphed'),
            selOver = $('<div class="selectOver"></div>'),
            wrap = sel.wrap('<div class="selectWrap">').parent(),
            update = function(selection) {
                var value = selection.attr('value') || '';
                selOver.text(selection.text());
                if (value!='') {
                    wrap.addClass('hasValue');
                } else {
                    wrap.removeClass('hasValue');
                }
            };
        selOver.prependTo(wrap);
        sel.on('change', function(e) {
            update(sel.find('option:selected'));
        }).on('keydown', function(e) {
            var el = $(this).children();
            if(e.which===38 && el.filter(':selected').prev().length!=0) { //up arrow
                update(el.filter(':selected').prev());
            } else if (e.which===40 && el.filter(':selected').next().length!=0) { //down arrow
                update(el.filter(':selected').next());
            }
        }).on('focus',function() {
            wrap.addClass('focus');
        }).on('blur',function() {
            wrap.removeClass('focus');
        }).trigger('change');

        sel.on('selectUpdate', function() {
            update(sel.find('option:selected'));
        });
    });

    $('.optsContainer > input:not(.optsCounter), .optsContainer > textarea').each(function() {
        var node = $(this),
            container = node.closest('.optsContainer'),
            check = function() {
                if (node.val()!='') {
                    container.addClass('hasValue');
                } else {
                    container.removeClass('hasValue');
                }
            };

        if (node.closest('.date').length!=0) {
            container = node.closest('.date');
        }

        node.on('change click', function() {
            check();
        });

        check();
    });

    function optsCounter(){
        var node = $(this).addClass('input-morphed'),
            parent = $(this).closest('.optsContainer').addClass('hasValue'),
            nodeOver = $('<div class="over"></div>'),
            wrap = node.wrap('<div class="optsCounterWrap">').parent(),
            unit = node.attr('data-unit') || '',
            max = 1,
            min = 0,
            step = 1,
            update = function () {
                var value = getValue();

                upBtn.removeClass('disabled');
                downBtn.removeClass('disabled');
                if (isNaN(value)) {
                    value = '';
                } else if (value >= max) {
                    value = max;
                    setValue(value);
                    upBtn.addClass('disabled');
                } else if (value <= min) {
                    value = min;
                    setValue(value);
                    downBtn.addClass('disabled');
                }

                if (node.is('select')) {
                    value = node.find('option').eq(value).text();
                }

                nodeOver.text(value + (unit != '' ? ' ' + unit : ''));

                node.trigger('change');
            },
            getValue = function () {
                var value = '';
                if (node.is('select')) {
                    value = node.prop('selectedIndex');
                } else {
                    value = $.trim(node.val());
                }

                return parseInt(value);
            },
            setValue = function (value) {
                if (node.is('select')) {
                    node.prop('selectedIndex', value);
                } else {
                    node.val(value);
                }
            },
            upBtn = $('<button type="button" class="optsCounterUp" aria-label="Anzahl erhöhen"><span class="icon icon-plus-circled noMargin"></span></button>').appendTo(wrap).on('click', function () {
                var value = getValue();

                if (isNaN(value)) {
                    setValue(min);
                    update();
                } else if ((value + step) <= max) {
                    value += step;
                    setValue(value);
                    update();
                }
            }),
            downBtn = $('<button type="button" class="optsCounterDown" aria-label="Anzahl verringern"><span class="icon icon-minus-circled noMargin"></span></button>').appendTo(wrap).on('click', function () {
                var value = getValue();

                if (isNaN(value)) {
                    setValue(min);
                    update();
                } else if ((value - step) >= min) {
                    value -= step;
                    setValue(value);
                    update();
                }
            });
        nodeOver.prependTo(wrap);

        if (node.is('select')) {
            max = node.find('option').length - 1;
            min = 0;
            step = 1;
        } else {
            max = parseInt(node.attr('max')) || 1;
            min = parseInt(node.attr('min')) || 0;
            step = parseInt(node.attr('step')) || 1;
        }

        node.on('change', function (e) {
            if (!('isTrigger' in e) || e.isTrigger != 3) {
                update();
            }
        }).on('focus', function (e) {
            if (!node.is('select') && 'select' in this) {
                this.select();
            }
        }).on('keydown keyup', function (e) {
            update();
        });

        update();
    }

    $('.optsCounter').each(optsCounter);

    /*Confirm Newsletter sign out*/
    $("#formField_newsletter").change(function(event) {
      event.preventDefault();
      if(!this.checked) {
        swal("Wenn Sie auf KONFIGURATION SPEICHERN klicken werden Sie vom Newsletter abgemeldet und Ihr Newsletter-Profil wird gelöscht und kann nicht wiederhergestellt werden.", {
          buttons: {
            cancel: "Abbrechen",
            deleteProfile: 'Verstanden',
          },
          title: "Wichtiger Hinweis",
          icon: "warning",
          closeOnClickOutside: false,
        })
            .then((value) => {
              switch (value) {

                case "deleteProfile":
                  $('#formField_newsletter').prop('checked', false);
                  break;

                default:
                  $('#formField_newsletter').prop('checked', true);
              }
            });
      }
    });



    /**
     * Name           : Akkordion
     * Beschreibung   :  nur übernommen
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : -
     */
    $('.accordion .accordionItem').each(function() {
        var wrap = $(this),
            header = wrap.find('.accordionTrigger'),
            content =  wrap.find('.accordionContent'),
            switcher = wrap.find('#' + header.attr('for')),
            setAria = function() {
                if (switcher.is(':checked')) {
                    header.attr({
                        'aria-selected' : 'true',
                        'aria-expanded' : 'true'
                    });
                    content.attr('aria-hidden', 'false');
                } else {
                    header.attr({
                        'aria-selected' : 'false',
                        'aria-expanded' : 'false'
                    });
                    content.attr('aria-hidden', 'true');
                }
            };

        content.attr('role', 'tabpanel');
        header.attr('role', 'tab');
        if (header.attr('id')) {
            header.attr('aria-controls', header.attr('id') + '_control');
            content.attr('aria-labelledby', header.attr('id'));
        }
        setAria();
        switcher.on('change', function() {
            setAria();
        });
    });

    /**
     * Name           : Skeletabs
     * Beschreibung   : plugin that provides tabbed browsing feature to your web contents
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, https://github.com/findawayer/Skeletabs
     */
    if ( $( '.tab-module' ).length ) {
        $('.tab-module').skeletabs({
            autoplay: false,
            panelHeight: 'adaptive',
            slidingAccordion: true,
        });
    }

    /**
     * Name           : Warning-Message
     * Beschreibung   : -
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */
    $(window).on('load',function(){
        if ( $( "#warning" ).length ) {
            //only show once per session - using sessionStorage
            if (!sessionStorage.getItem('central-warning')){
                showmessage();
                sessionStorage.setItem('central-warning','viewed')
            }
        }

        function showmessage(){
            $('.darken_content').css({
              'opacity' :'0.96',
              'z-index' : '10'
            });
            $('#warning').show().delay(300).queue(function(){
                $(this).addClass('active');
            });
        }
    });

    $('.closeWarning').on('click', function() {
       $('#warning').hide();
       $('.darken_content').css({
           'opacity' :'0',
           'z-index' : '-1'
       });
    });

    /**
     * Name           : Parsley Form Validation
     * Beschreibung   : -
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */
    if ( $( ".formLabelIncluded" ).length ) {
        $('.formLabelIncluded').parsley({
            errorsWrapper: '<div class="error"></div>',
            errorTemplate: '<div class="parsley-error"></div>',
            trigger: 'blur'
        });
    }



    /**
     * Name           : Booking
     * Beschreibung   : Im Buchungsformular werden die Daten erfasst (bei Kindern audh das Alter) und an lausitzerseenland.de übergeben
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */
    if($('#qb_form').length){
        var wrapper = $('.child-count-wrapper'); //Input field wrapper
        var childrenCount = parseInt($('#qb_children').val());
        $('#qb_children').on('change', function() {
            var totalItems = this.value; //Ziel-Anzahl-Kinder
            var newItems = totalItems - childrenCount; //neu hinzuzufügende Anzahl an Kindern
            var actualItems = $(wrapper).children().length; //aktuell evtl. vorhandene Kinder

            if( totalItems > actualItems){
                //Add Children-Age-Fields according to number of children
                 for (var i = actualItems; i < newItems; i++) {
                     var n = i + 1;
                     //$(wrapper).append('<div class="optsContainer optsCompactContainer"><input type="number" max="17"required name="childCount-' + n + '" id="child' + childrenCount + '" value=""><label for="child' + n + '">Alter des ' + n + '. Kindes</label></div>'); //Add field html
                     $(wrapper).append('<div class="optsContainer optsCompactContainer qb_child_age"><select name="childCount-' + n + '" id="child' + childrenCount + '" class="optsCounterNew" required><option value="">--</option><option value="1">1 Jahr</option><option value="2">2 Jahre</option><option value="3">3 Jahre</option><option value="4">4 Jahre</option><option value="5">5 Jahre</option><option value="6">6 Jahre</option><option value="7">7 Jahre</option><option value="8">8 Jahre</option><option value="9">9 Jahre</option><option value="10">10 Jahre</option><option value="11">11 Jahre</option><option value="12">12 Jahre</option><option value="13">13 Jahre</option><option value="14">14 Jahre</option><option value="15">15 Jahre</option><option value="16">16 Jahre</option><option value="17">17 Jahre</option><option value="18">18 Jahre</option><option value="19">19 Jahre</option><option value="20">20 Jahre</option></select><label for="child' + n + '">Alter des ' + n + '. Kindes</label><span class="icon noMargin icon-child"></span></div>'); //Add field html
                     $(wrapper).find('.optsCounterNew').each(optsCounter).removeClass('optsCounterNew').addClass('optsCounter');
                 }
            }
            else{
                //Remove unnecessary items
                $(wrapper).children().slice(totalItems, actualItems).remove();
            }
        });

        // $('.child-count-wrapper').on('blur', 'input', function(){
        //     if ( $(this).val() != '' ) {
        //         $(this).closest('.optsCompactContainer').addClass('hasValue');
        //     }
        //     else {
        //         $(this).closest('.optsCompactContainer').removeClass('hasValue');
        //     }
        // })

        $('#qb_form').on('submit', function(e){
            e.preventDefault();
            //Datum in benötigtes Format umwandeln
            function dateconv(convdate){
                var d=new Date(convdate.split(".").reverse().join("-"));
                var dd=('0' + (d.getDate())).slice(-2);
                var mm=('0' + (d.getMonth()+1)).slice(-2);
                var yy=d.getFullYear();
                var convDate = yy+"-"+mm+"-"+dd;
                return convDate;
            }
            //Arrival
            var arrival = $('#qb_arrival').val();
            var arrivalDate = dateconv(arrival);
            //Departure
            var departure = $('#qb_departure').val();
            var departureDate = dateconv(departure);
            //Adults
            var adults = $('#qb_adult').val();
            //Children
            var childrenAges = [];
            $('.child-count-wrapper select :selected').each(function(i, selected){
                childrenAges[i] = $(selected).val();
            });
            //Link zusammenbauen
            var formUrl = 'https://lp.lausitzerseenland.de/de/unterkunfte-in-forst-lausitz?from=' + arrivalDate +'&to=' + departureDate +'&region=we39c0c73b03ce0&occupation=4&only-additional-rooms=1&additional_occupancy_data=[{"adults":"' + adults + '","children_ages":[' + childrenAges +'],"children":[' + childrenAges +']}]&page=1#ibe-list';
            //Seite öffnen
            var win = window.open(formUrl, '_blank');
            //Open formUrl
            if (win) {
                //Browser has allowed it to be opened
                win.focus();
            } else {
                //Browser has blocked it
                alert('Bitte erlauben Sie Popups für diese Seite.');
            }
        });

    }









}
